import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, Button, Chip, IconButton } from '@material-ui/core';
import WEditor from 'wangeditor';
import { globalData, invoiceEmailTemplate } from "../../../common/common";
import { clone, validateEmail } from '../../../common/utils';
import Add from '@material-ui/icons/Add';

const Root = styled(Box)({
    width: '1000px',
    padding: '24px',
    '& .pageTitle': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#005E96',
    },
    '& .wdWapper': {
        width: '100%',
        margin: '20px 0',
    },
    '& .send-title': {
        marginTop: '15px',
    },
    '& .chip-wapper': {
        width: '100%',
        marginTop: '5px',
    },
    '& .chip': {
        margin: '5px',
    },
    '& .wapper': {
        width: '100%',
        margin: '20px 0',
        backgroundColor: '#FAFAFA',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#A1A1A1',
        opacity: '0.12',
        margin: '20px 0',
    },
    '& .title': {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#0060A0',
        margin: '10px 0 26px 0',
    },
    '& .title2': {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#142D33',
    },
    '& .pdfBtn': {
        width: '200px',
        margin: '0 20px',
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginRight: '20px',
        },
    },
    '& .mt-20': {
        marginTop: '20px',
    },
})

class Email extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: "",
            subject: "",
            ccEmailData: [],
            tempEmail: "",
            isClickAdd: false,
            emailTfState: false,
            emailTfText: "",

            totalDOTData: [],
            officeData: [],
            departmentsData: [],
            teamsData: [],
            membersData: [],
        }
        this.handleSendEmail = this.handleSendEmail.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleAddEmail = this.handleAddEmail.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.onKeyup = this.onKeyup.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
    }
    render() {
        const {
            ccEmailData,
            isClickAdd,
            tempEmail,
            emailTfState,
            emailTfText,
        } = this.state;
        const { emailHtml, toEmail } = this.props;
        const addEmail = () => {
            if (isClickAdd) {
                return <TextField
                    size="small"
                    margin="dense"
                    variant="outlined"
                    label="Email Address"
                    error={emailTfState}
                    helperText={emailTfText}
                    value={tempEmail}
                    onChange={this.handleChange}
                    onKeyUp={this.onKeyup}
                    autoFocus={true}
                    onBlur={this.handleBlur}
                    style={{ marginLeft: '10px' }}
                />
            } else {
                return <IconButton onClick={this.handleAddEmail}>
                    <Add fontSize="small" />
                </IconButton>
            }
        }
        return (
            <Root>
                <div className="title c">SEND THE INVOICE TO CONTACT’S EMAIL</div>
                <div className="title2">Email Content</div>
                <div className="h mt-20">
                    <div>To:</div>
                    <div>
                        <Chip
                            size="small"
                            label={toEmail}
                            className="chip"
                        />
                    </div>
                </div>
                <div className="h h-t">
                    <div className="send-title">Cc:</div>
                    <div className="chip-wapper h flow">
                        {ccEmailData.map((data, index) => (
                            <Chip
                                size="small"
                                key={index}
                                label={data}
                                onDelete={e => this.handleDelete(e, index)}
                                className="chip"
                            />
                        ))}
                        {addEmail()}
                    </div>
                </div>
                <div className="wdWapper">
                    <div id="wd"></div>
                </div>
                <div className="title2">Invoice Preview</div>
                <div className="wapper v">
                    <div
                        dangerouslySetInnerHTML={{ __html: emailHtml }}
                    />
                </div>
                <div className="line"></div>
                <div className="foot h h-c">
                    <Button className="pdfBtn" variant="contained" onClick={this.handleCancel}>CANCEL</Button>
                    <Button className="pdfBtn" variant="contained" color="primary" onClick={this.handleSendEmail}>SEND EMAIL INVOICE</Button>
                </div>
            </Root>
        )
    }
    componentDidMount() {
        this.wd = new WEditor("#wd");
        this.wd.customConfig.lang = {
            '设置标题': 'title',
            '正文': 'p',
            '链接文字': 'link text',
            '链接': 'link',
            '上传图片': 'upload image',
            '上传': 'upload',
            '创建': 'init',
            '背景色': 'background color',
            '文字颜色': 'text color',
            '字号': 'font size',
            '字体': 'font',
            '宋体': 'SimSun',
            '微软雅黑': 'Microsoft YaHei',
            '设置列表':'setting list',
            '有序列表':'numbered list',
            '无序列表':'unordered list',
            '对齐方式':'alignment',
            '靠左':'left',
            '居中':'center',
            '靠右':'right',
            '默认':'default',
            '新浪':'sina',
            '网络图片':'web image',
            '图片Link':'image link',
            '插入表格':'insert table',
            '行':'row',
            '列':'column',
            '的表格':' table',
            '插入视频':'insert video',
            '格式如：':'format: ',
            '插入代码':'insert code',
            '插入':'insert',
        };
        this.wd.create();
        this.wd.txt.html(invoiceEmailTemplate(this.props.contactName));
        const ccEmailData = this.state.ccEmailData;
        ccEmailData.push(globalData.userInfo.email);
        this.setState(() => ({
            ccEmailData
        }));
    }
    handleSendEmail() {
        const { emailHtml } = this.props;
        const { ccEmailData } = this.state;
        const textHtml = this.wd.txt.html();
        this.props.handleSendEmail(textHtml, emailHtml, ccEmailData);
    }
    handleDelete(e, delIndex) {
        const ccEmailData = clone(this.state.ccEmailData);
        ccEmailData.splice(delIndex, 1);
        this.setState(() => ({
            ccEmailData
        }))
    }
    handleAddEmail() {
        this.clickAdd();
    }
    handleChange(e) {
        const tempEmail = e.target.value;
        this.setState(() => ({
            tempEmail
        }));
    }
    onKeyup(e) {
        if (e.keyCode === 13) {
            this.validateInput();
        }
    }
    handleBlur(e) {
        this.validateInput();
    }
    handleCancel() {
        this.props.handleCancel();
    }
    addCancel() {
        this.clickAdd();
        this.tfErr();
    }
    validateInput() {
        const { tempEmail } = this.state;
        if (tempEmail === "") {
            this.addCancel();
            return;
        } else if (!validateEmail(tempEmail)) {
            this.tfErr(true, "email format error");
            return;
        }
        this.addEmailToList();
        this.clickAdd();
    }
    clickAdd() {
        const isClickAdd = this.state.isClickAdd;
        this.setState(() => ({
            isClickAdd: !isClickAdd
        }))
    }
    addEmailToList() {
        this.tfErr();
        const ccEmailData = clone(this.state.ccEmailData);
        ccEmailData.push(this.state.tempEmail);
        this.setState(() => ({
            ccEmailData,
            tempEmail: ""
        }))
    }
    tfErr(state = false, value = "") {
        this.setState(() => ({
            emailTfState: state,
            emailTfText: value
        }))
    }
}

export default Email;